import styled, { css } from 'styled-components';

const MEDIA_HEIGHT = '15rem';
const MEDIA_RATIO = '9 / 16';

const mediaFrame = css`
  display: block;
  align-self: flex-start;
  height: ${MEDIA_HEIGHT};
  aspect-ratio: ${MEDIA_RATIO};
  max-width: 100%;
  border-radius: 0.75rem;
  background: #000;
  object-fit: contain;
`;

export const StyledAttachmentList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 0.5rem;
`;

export const StyledVideo = styled.video`
  ${mediaFrame}
`;

export const StyledUnavailable = styled.div`
  padding: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  background: rgba(0, 0, 0, 0.06);
  font-size: 0.875rem;
  opacity: 0.75;
`;
